import React, { useContext } from "react";
import { Col, Layout, Row, Divider, Space } from "antd";
import CONSTANTS from "constants/constants";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  InstagramFilled,
  YoutubeFilled,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Context } from "Context";

const Footer = () => {
  const { setCurrent } = useContext(Context);
  const { Footer } = Layout;
  const { FOOTER } = CONSTANTS;

  const handleClick = (e) => {
    setCurrent(e.target.pathname);
  };

  return (
    <Footer className="footer">
      <Row align="middle" gutter={[16, 32]}>
        <Col lg={10} md={24} sm={24} xs={24} className="footer-text-main">
          <Row className="footer-text-main-head">{FOOTER.EV}</Row>
          <Row className="footer-text-main-text">{FOOTER.EV_TEXT}</Row>
        </Col>
        <Col
          lg={4}
          md={8}
          sm={8}
          xs={12}
          className="footer-text-links footer-text footer-links"
        >
          <Row>
            <Link to="/" onClick={handleClick}>
              {FOOTER.HOME}
            </Link>
          </Row>
          <Row>
            <Link to="/aboutUs" onClick={handleClick}>
              {FOOTER.ABOUT_US}
            </Link>
          </Row>
          <Row>
            <Link to="/contactUs" onClick={handleClick}>
              {FOOTER.CONTACT_US}
            </Link>
          </Row>
        </Col>
        <Col lg={4} md={8} sm={8} xs={12} className="footer-text footer-links">
          <Row>
            <Link to="/ourServices/prodRed" onClick={handleClick}>
              {FOOTER.OUR_SERVICES}
            </Link>
          </Row>
          <Row>
            <Link to="/ourServices/prodRed" onClick={handleClick}>
              {FOOTER.PRODRED}
            </Link>
          </Row>
          <Row>
            <Link to="/ourServices/dvt" onClick={handleClick}>
              {FOOTER.DVT}
            </Link>
          </Row>
        </Col>
        <Col lg={4} md={8} sm={8} xs={24} className="footer-text">
          <Row>
            <Space>
              <FontAwesomeIcon icon={faPhone} />
              {FOOTER.PHONE}
            </Space>
          </Row>
          <Row>
            <Space>
              <FontAwesomeIcon icon={faEnvelope} />
              <Row>{FOOTER.MAIL}</Row>
            </Space>
          </Row>
          <Row>
            <Space>
              <FontAwesomeIcon icon={faLocationDot} />
              <Row>{FOOTER.ADDRESS}</Row>
            </Space>
          </Row>
        </Col>
      </Row>
      <Divider className="footer-divider" />
      <Row className="footer-text-rights" gutter={[16, 16]}>
        <Col className="footer-rights-text">{FOOTER.RIGHTS}</Col>
        <Col className="footer-icons">
          <Space size={32}>
            {[
              <FacebookFilled />,
              <TwitterSquareFilled />,
              <LinkedinFilled />,
              <InstagramFilled />,
              <YoutubeFilled />,
            ].map((icon, index) => (
              <Link to="#" key={index}>
                {icon}
              </Link>
            ))}
          </Space>
        </Col>
      </Row>
    </Footer>
  );
};

export default Footer;
